import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { ComboById, ComboByIdVariables } from "./types/ComboById";
import { Combos, CombosVariables } from "./types/Combos";
export const combosListFragment = gql`
  fragment CombosListFragment on Combo {
    id
    name
    totalPrice
    enable
    lastChange
    orderNumber
    products(first: 100) {
      totalCount
      edges {
        node {
          name
        }
      }
    }
  }
`;
export const comboDetailsFragment = gql`
  ${combosListFragment}
  fragment ComboDetailsFragment on Combo {
    ...CombosListFragment
    orderList {
      id
      number
    }
    labelText
    labelLink
    comboProducts {
      id
      sortOrder
      discountPrice
      product {
        id
        thumbnail {
          url
        }
        productType {
          name
        }
        isPublished
        name
        defaultVariant {
          price {
            amount
          }
        }
      }
      discountLocalPrice {
        currency
        amount
      }
    }
  }
`;
export const combos = gql`
  ${combosListFragment}
  ${pageInfoFragment}
  query Combos(
    $after: String
    $first: Int
    $last: Int
    $before: String
    $filter: ComboFilterInput
    $sort: ComboSortingInput
  ) {
    combos(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...CombosListFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export const useCombosQuery = makeQuery<Combos, CombosVariables>(combos);

export const comboById = gql`
  ${comboDetailsFragment}
  query ComboById($id: ID!) {
    comboById(id: $id) {
      ...ComboDetailsFragment
    }
  }
`;

export const useComboByIdQuery = makeQuery<ComboById, ComboByIdVariables>(
  comboById
);
